import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _NoteAssetItemFields;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { utils } from '@cofit/api';
import dayjs from 'dayjs';
import * as R from 'ramda';
import { DEFAULT_EE_VALUE, FoodNoteItemCalorieOr3NutritionQuickAddKindAttr, MACROS_6_FOOD_CATEGORIES_WITH_SUBCATEGORIES, MEALS, NutritionConstant } from 'src/constants/diet';
import { DietTagsOptions } from 'src/constants/diet_tags';
import { FoodNoteItemQuickAddType, FoodNoteItemType, MoveAssetItemType, NUTRITION_KEY, NoteAssetItemType, NoteType, SIX_FOOD_CATEGORY, THREE_NUTRITION, TargetType } from 'src/types/diet';
import { Suggestion } from './nutrition/Suggestion';
import { calcItemAmountFromCalorieOr3NutritionQuickAddItem } from './nutrition/calculator';
import { getFoodNoteItemCalorieQuickAddKindAttr } from './nutrition/converter';
var MACROS_3_NUTRITION_UNIT_CAL = NutritionConstant.MACROS_3_NUTRITION_UNIT_CAL;
export var getTargetType = function getTargetType(start_weight, target_weight) {
  var delta = target_weight - start_weight;

  if (delta === 0) {
    return TargetType.MAINTAIN_WEIGHT;
  } else if (delta < 0) {
    return TargetType.LOSE_WEIGHT;
  } else {
    return TargetType.GAIN_WEIGHT;
  }
};
export var getDefaultTarget = function getDefaultTarget(ee) {
  var _ref;

  var suggestion = new Suggestion(ee);
  return _ref = {}, _defineProperty(_ref, THREE_NUTRITION.protein, suggestion.protein), _defineProperty(_ref, THREE_NUTRITION.fat, suggestion.fat), _defineProperty(_ref, THREE_NUTRITION.carbohydrate, suggestion.carbohydrate), _defineProperty(_ref, NUTRITION_KEY.calorie, suggestion.calories), _defineProperty(_ref, SIX_FOOD_CATEGORY.fruits, suggestion.fruits), _defineProperty(_ref, SIX_FOOD_CATEGORY.vegetables, suggestion.vegetables), _defineProperty(_ref, SIX_FOOD_CATEGORY.grains, suggestion.grains), _defineProperty(_ref, SIX_FOOD_CATEGORY.oil, suggestion.oil), _defineProperty(_ref, SIX_FOOD_CATEGORY.milk_low_fat, suggestion.milk_low_fat), _defineProperty(_ref, SIX_FOOD_CATEGORY.meat_beans_low_fat, suggestion.meat_beans_low_fat), _defineProperty(_ref, SIX_FOOD_CATEGORY.meat_beans_medium_fat, suggestion.meat_beans_medium_fat), _defineProperty(_ref, "water", 2000), _defineProperty(_ref, "weekly", '0'), _defineProperty(_ref, "start_weight", 0), _defineProperty(_ref, "target_weight", 0), _defineProperty(_ref, "kg", TargetType.LOSE_WEIGHT), _defineProperty(_ref, "isDefault", true), _ref;
};
export var getPercentageOf3Nutrition = function getPercentageOf3Nutrition(row, type) {
  return (100 * (row[type] * MACROS_3_NUTRITION_UNIT_CAL[type]) / (row[THREE_NUTRITION.protein] * MACROS_3_NUTRITION_UNIT_CAL[THREE_NUTRITION.protein] + row[THREE_NUTRITION.carbohydrate] * MACROS_3_NUTRITION_UNIT_CAL[THREE_NUTRITION.carbohydrate] + row[THREE_NUTRITION.fat] * MACROS_3_NUTRITION_UNIT_CAL[THREE_NUTRITION.fat])).toFixed(2);
};
export var isSixGroupNoteAssetItem = function isSixGroupNoteAssetItem(item) {
  return item.item_type === FoodNoteItemType.quickAdd && (item.quick_add_type === FoodNoteItemQuickAddType.sixGroup || item.quick_add_type === FoodNoteItemQuickAddType.namedSixGroup);
};
export var isFoodStuffNoteAssetItem = function isFoodStuffNoteAssetItem(item) {
  return item.item_type === FoodNoteItemType.foodStuff;
};
export var isCalorieNoteAssetItem = function isCalorieNoteAssetItem(item) {
  return item.item_type === FoodNoteItemType.quickAdd && item.quick_add_type === FoodNoteItemQuickAddType.calorie;
};
export var is3NutritionNoteAssetItem = function is3NutritionNoteAssetItem(item) {
  return item.item_type === FoodNoteItemType.quickAdd && item.quick_add_type === FoodNoteItemQuickAddType.macros;
};
export var isCalorieOr3NutritionNoteAssetItem = function isCalorieOr3NutritionNoteAssetItem(item) {
  return is3NutritionNoteAssetItem(item) || isCalorieNoteAssetItem(item);
};
export var getNoteAssetItemName = function getNoteAssetItemName(type, item) {
  var _item$item_details, _item$item_details2, _item$item_details3;

  switch (type) {
    case NoteAssetItemType.foodStuff:
      return "".concat(item !== null && item !== void 0 && (_item$item_details = item.item_details) !== null && _item$item_details !== void 0 && _item$item_details.brand ? "".concat(item === null || item === void 0 ? void 0 : (_item$item_details2 = item.item_details) === null || _item$item_details2 === void 0 ? void 0 : _item$item_details2.brand, " ") : '').concat(item === null || item === void 0 ? void 0 : (_item$item_details3 = item.item_details) === null || _item$item_details3 === void 0 ? void 0 : _item$item_details3.name);

    case NoteAssetItemType.sixGroup:
    case NoteAssetItemType.calorieOr3Nutrition:
      return item === null || item === void 0 ? void 0 : item.item_name;
  }
};
export var NoteAssetItemFields = (_NoteAssetItemFields = {}, _defineProperty(_NoteAssetItemFields, NoteAssetItemType.sixGroup, {
  type: NoteAssetItemType.sixGroup,
  text: '六大類',
  textKey: 'client_mgmt:normal.sixCategory',
  filter: isSixGroupNoteAssetItem,
  getDescription: function getDescription(item, t) {
    var _Number, _Number$toFixed, _item$calorie;

    return "".concat((_Number = Number((_item$calorie = item === null || item === void 0 ? void 0 : item.calorie) !== null && _item$calorie !== void 0 ? _item$calorie : 0)) === null || _Number === void 0 ? void 0 : (_Number$toFixed = _Number.toFixed) === null || _Number$toFixed === void 0 ? void 0 : _Number$toFixed.call(_Number, 2), " ").concat(t('client_mgmt:move.kcal', '大卡'));
  }
}), _defineProperty(_NoteAssetItemFields, NoteAssetItemType.foodStuff, {
  type: NoteAssetItemType.foodStuff,
  text: '資料庫',
  textKey: 'client_mgmt:normal.database',
  filter: isFoodStuffNoteAssetItem
}), _defineProperty(_NoteAssetItemFields, NoteAssetItemType.calorieOr3Nutrition, {
  type: NoteAssetItemType.calorieOr3Nutrition,
  text: '速加熱量 / 三大類',
  textKey: 'client_mgmt:diet.quickAddCalorieAndThreeNutrition',
  filter: isCalorieOr3NutritionNoteAssetItem,
  getDescription: function getDescription(item, t) {
    var _Number2, _item$calorie2;

    return "".concat((_Number2 = Number((_item$calorie2 = item === null || item === void 0 ? void 0 : item.calorie) !== null && _item$calorie2 !== void 0 ? _item$calorie2 : 0)) === null || _Number2 === void 0 ? void 0 : _Number2.toFixed(2), " ").concat(t('client_mgmt:move.kcal', '大卡'));
  }
}), _NoteAssetItemFields);
export var getAggregationInKeys = function getAggregationInKeys(keyListToAggregate) {
  var initialAggregation = R.reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, 0));
  }, {}, keyListToAggregate);
  return R.pipe(R.map(R.pickAll(keyListToAggregate)), R.reduce(R.mergeWith(function (a, b) {
    return Math.round(R.add(Number(a !== null && a !== void 0 ? a : 0), Number(b !== null && b !== void 0 ? b : 0)) * 100) / 100;
  }), initialAggregation));
};
export var pickSixFoodAttributes = R.pick(NutritionConstant.SIXGROUPS);
export var getDailySummaryByNotes = function getDailySummaryByNotes(_ref2) {
  var date = _ref2.date,
      notes = _ref2.notes,
      targets = _ref2.targets,
      clientInfo = _ref2.clientInfo;
  var ee = R.pathOr(DEFAULT_EE_VALUE, ['current', 'ee'], clientInfo);
  var target = getClientTarget({
    date: dayjs(date).format('YYYY-MM-DD'),
    targets: targets,
    ee: ee
  }) || getDefaultTarget(ee);
  return getDailyStatistics({
    date: dayjs(date).format('YYYY-MM-DD'),
    notes: notes,
    target: target
  });
};
export var getDailyStatistics = function getDailyStatistics(_ref3) {
  var _target$calorie, _dailyAggregation$cal;

  var date = _ref3.date,
      _ref3$notes = _ref3.notes,
      notes = _ref3$notes === void 0 ? [] : _ref3$notes,
      target = _ref3.target;
  var isWaterNote = R.propEq(NoteType.WaterNote, 'type');
  var isFoodNote = R.propEq(NoteType.FoodNote, 'type');
  var isMoveNote = R.propEq(NoteType.MoveNote, 'type');
  var isDateEqual = R.propEq(date, 'date');
  var foodNotes = R.filter(R.allPass([isDateEqual, isFoodNote]), notes);
  var moveNotes = R.filter(R.allPass([isDateEqual, isMoveNote]), notes);
  var waterNotes = R.filter(R.allPass([isDateEqual, isWaterNote]), notes);
  var waterItems = R.map(R.pathOr({}, ['items', 0]), waterNotes);
  var filteredNotes = [].concat(_toConsumableArray(foodNotes), _toConsumableArray(waterItems));
  var keysToAggregate = [].concat(_toConsumableArray(MACROS_6_FOOD_CATEGORIES_WITH_SUBCATEGORIES), _toConsumableArray(NutritionConstant.MACROS_3_NUTRITION), [NUTRITION_KEY.calorie, 'water_intake']);
  var dailyAggregation = getAggregationInKeys(keysToAggregate)(filteredNotes);
  var burned = getSumOfKeyFromList(NUTRITION_KEY.calorie)(moveNotes);
  var targetCalorie = Number((_target$calorie = target.calorie) !== null && _target$calorie !== void 0 ? _target$calorie : 0);
  var ingestedCalorie = Number((_dailyAggregation$cal = dailyAggregation.calorie) !== null && _dailyAggregation$cal !== void 0 ? _dailyAggregation$cal : 0);
  var calorieSummary = {
    target: targetCalorie,
    ingested: ingestedCalorie,
    burned: burned,
    rest: targetCalorie - ingestedCalorie + burned
  };
  var sixFoodCategorySummary = aggregateSixCategoryFromSubCategory(dailyAggregation, target);
  var sixFoodCategoryByMeal = getSixFoodCategoryByMeal(pickSixFoodAttributes(dailyAggregation), pickSixFoodAttributes(target), foodNotes);
  return _objectSpread(_objectSpread({}, dailyAggregation), {}, {
    sixFoodCategoryByMeal: sixFoodCategoryByMeal,
    sixFoodCategorySummary: sixFoodCategorySummary,
    calorieSummary: calorieSummary
  });
};
export var getSixFoodCategoryByMeal = function getSixFoodCategoryByMeal(ingested, target, foodNotes) {
  return R.pipe(R.values, R.map(function (meal) {
    return R.pipe(R.filter(R.propEq(meal.meal_order_id, 'meal_order')), getAggregationInKeys(MACROS_6_FOOD_CATEGORIES_WITH_SUBCATEGORIES), R.mergeWithKey(function (k, l, r) {
      return r || l;
    }, meal))(foodNotes);
  }), R.concat([_objectSpread({
    i18n: 'meal.total',
    text: '當日加總'
  }, ingested)]), R.concat([_objectSpread({
    i18n: 'meal.target',
    text: '建議'
  }, target)]))(MEALS);
};
export var getClientTarget = function getClientTarget(_ref4) {
  var date = _ref4.date,
      _ref4$targets = _ref4.targets,
      targets = _ref4$targets === void 0 ? [] : _ref4$targets;
  var dateString = date;
  var target = R.pipe(R.filter(function (_ref5) {
    var beginDate = _ref5.begin_date,
        endDate = _ref5.end_date;
    return beginDate <= dateString && dateString <= endDate;
  }), R.sortWith([R.descend(R.prop('created_at'))]), R.path([0]))(targets);
  return target;
};
export var aggregateSixCategoryFromSubCategory = function aggregateSixCategoryFromSubCategory(ingested, target) {
  return R.map(function (category) {
    var key = category.key,
        Icon = category.Icon,
        _category$subCategory = category.subCategoryKeys,
        subCategoryKeys = _category$subCategory === void 0 ? [] : _category$subCategory;
    return {
      key: key,
      Icon: Icon,
      target: R.pipe(R.propOr([key], 'subCategoryKeys'), R.map(R.propOr(0, R.__, target)), R.sum, utils.Util.round)(category),
      ingested: R.pipe(R.propOr([key], 'subCategoryKeys'), R.map(R.propOr(0, R.__, ingested)), R.sum, utils.Util.round)(category),
      subCategories: R.pick(subCategoryKeys, ingested)
    };
  }, NutritionConstant.SIX_FOOD_CATEGORIES);
};
export var filterAerobic = function filterAerobic(items) {
  return R.filter(function (_ref6) {
    var _ref6$item = _ref6.item,
        item = _ref6$item === void 0 ? {} : _ref6$item,
        _ref6$items = _ref6.items,
        items = _ref6$items === void 0 ? [] : _ref6$items;
    var checkAerobicItems = R.find(function (_ref7) {
      var item = _ref7.item;

      if (item) {
        var _category = item.category,
            _category_name = item.category_name;

        var _categoryIsObject = R.is(Object, _category_name);

        return _category === 'measurement' || _category === 'workout' || _categoryIsObject;
      } else {
        return true;
      }
    }, items);
    var category = item.category,
        category_name = item.category_name;
    var categoryIsObject = R.is(Object, category_name);
    return category !== 'measurement' && category !== 'workout' && !checkAerobicItems && !categoryIsObject;
  }, items);
};
export var getSumOfKeyFromList = function getSumOfKeyFromList(key) {
  return R.pipe(R.map(R.propOr(0, key)), R.map(Number), R.sum, R.defaultTo(0));
};
export var normalizeMoveNote = function normalizeMoveNote(note) {
  var _note$items = note.items,
      items = _note$items === void 0 ? [] : _note$items,
      _note$move_sessions = note.move_sessions,
      move_sessions = _note$move_sessions === void 0 ? [] : _note$move_sessions;
  var aerobicItems = filterAerobic(items);
  var workoutItems = R.filter(R.pathEq('workout', ['item', 'category']), items);
  var sessionItems = R.pipe(R.chain(function (session) {
    return R.map(function (item) {
      return _objectSpread(_objectSpread(_objectSpread({}, item), R.omit(['items'], session)), {}, {
        calorie: R.propOr(0, 'measure_calorie', session)
      });
    }, R.propOr([], 'items', session));
  }))(move_sessions);
  var extraInfo = [{
    key: MoveAssetItemType.aerobic,
    items: aerobicItems
  }, {
    key: MoveAssetItemType.workout,
    items: workoutItems
  }, {
    key: MoveAssetItemType.session,
    items: sessionItems
  }];
  return _objectSpread(_objectSpread({}, note), {}, {
    extraInfo: extraInfo
  });
}; // fixed for FoodNoteAssetItem generated by PRO Web I

export var normalizeFoodNoteAssetItem = function normalizeFoodNoteAssetItem(item) {
  var _item$kind, _getFoodNoteItemCalor, _item$item_amount, _item$item_name, _objectSpread3;

  return _objectSpread(_objectSpread({}, item), {}, (_objectSpread3 = {
    kind: (_item$kind = item.kind) !== null && _item$kind !== void 0 ? _item$kind : (_getFoodNoteItemCalor = getFoodNoteItemCalorieQuickAddKindAttr(item)) === null || _getFoodNoteItemCalor === void 0 ? void 0 : _getFoodNoteItemCalor.key,
    item_amount: (_item$item_amount = item.item_amount) !== null && _item$item_amount !== void 0 ? _item$item_amount : calcItemAmountFromCalorieOr3NutritionQuickAddItem(item),
    item_name: (_item$item_name = item.item_name) !== null && _item$item_name !== void 0 ? _item$item_name : getDefaultQuickAddItemName(item, function (key, text) {
      return text;
    })
  }, _defineProperty(_objectSpread3, NUTRITION_KEY.refined_sugar, R.propOr(0, 'refined_sugar', item)), _defineProperty(_objectSpread3, "refined_sugar_percentage", R.propOr(0, 'refined_sugar_percentage', item)), _objectSpread3));
};
export var getDefaultValueForFoodNoteAssetTags = function getDefaultValueForFoodNoteAssetTags(asset) {
  var emptyTags = R.mapObjIndexed(function () {
    return [];
  }, DietTagsOptions);
  var originalTags = R.propOr(emptyTags, 'diet_tags', asset);
  return R.mapObjIndexed(function (_, key) {
    var _originalTags$key;

    return (_originalTags$key = originalTags[key]) !== null && _originalTags$key !== void 0 ? _originalTags$key : [];
  }, DietTagsOptions);
};
export var normalizeFoodNoteAsset = function normalizeFoodNoteAsset(asset) {
  return _objectSpread(_objectSpread({}, asset), {}, {
    refined_sugar: R.propOr(0, 'refined_sugar', asset),
    refined_sugar_percentage: R.propOr(0, 'refined_sugar_percentage', asset),
    items: R.map(normalizeFoodNoteAssetItem, asset.items),
    diet_tags: getDefaultValueForFoodNoteAssetTags(asset)
  });
};
export var normalizeFoodNote = function normalizeFoodNote(note, target) {
  return _objectSpread(_objectSpread({}, note), {}, {
    sixFoodCategorySummary: aggregateSixCategoryFromSubCategory(note, target),
    assets: R.pipe(R.propOr({}, 'assets'), R.map(normalizeFoodNoteAsset))(note),
    tag_ids: R.pluck('id', note.tags)
  });
};
export var normalizeNotes = function normalizeNotes(target) {
  return R.map(function (note) {
    return R.pipe(R.when(R.propEq(NoteType.MoveNote, 'type'), normalizeMoveNote), R.when(R.propEq(NoteType.FoodNote, 'type'), function (note) {
      return normalizeFoodNote(note, target);
    }))(note);
  });
};
export var omitC3P = R.omit([].concat(_toConsumableArray(NutritionConstant.MACROS_3_NUTRITION), _toConsumableArray(NutritionConstant.MACROS_3_NUTRITION_PERCENTAGE_KEYS), [NUTRITION_KEY.calorie, 'sixFoodCategorySummary']));

var mergeNewComment = function mergeNewComment(asset) {
  var _asset$newComment;

  return (_asset$newComment = asset.newComment) !== null && _asset$newComment !== void 0 && _asset$newComment.content ? asset.comments.concat(asset.newComment) : asset.comments;
};

export var postProcessAssets = function postProcessAssets(assets) {
  return R.map(R.pipe(R.omit(['sixFoodCategorySummary']), function (asset) {
    return _objectSpread(_objectSpread({}, asset), {}, {
      comments: mergeNewComment(asset)
    });
  }))(assets);
};
export var getAssetImageFallbackTexts = function getAssetImageFallbackTexts(_ref8) {
  var items = _ref8.items,
      text = _ref8.text;
  var assetItems = items || [];
  var assetItemsTexts = assetItems.filter(function (item) {
    return !!item.text && !item._destroy;
  }).map(function (item) {
    return item.item_name;
  });
  return (assetItemsTexts === null || assetItemsTexts === void 0 ? void 0 : assetItemsTexts.length) > 0 ? assetItemsTexts : text === null || text === void 0 ? void 0 : text.split('\n');
};
export var getDefaultCalorieOr3NutritionItemName = function getDefaultCalorieOr3NutritionItemName(type, kind, t) {
  var _FoodNoteItemCalorieO;

  var attr = (_FoodNoteItemCalorieO = FoodNoteItemCalorieOr3NutritionQuickAddKindAttr[type]) === null || _FoodNoteItemCalorieO === void 0 ? void 0 : _FoodNoteItemCalorieO[kind];

  if (attr !== null && attr !== void 0 && attr.i18n || attr !== null && attr !== void 0 && attr.item_name) {
    return t(attr === null || attr === void 0 ? void 0 : attr.i18n, attr === null || attr === void 0 ? void 0 : attr.item_name);
  }

  return t('client_mgmt:normal.defaultName', '未命名食物');
};
export var getDefaultQuickAddItemName = function getDefaultQuickAddItemName(item, t) {
  var item_type = item.item_type,
      quick_add_type = item.quick_add_type,
      kind = item.kind;

  if (item_type === FoodNoteItemType.quickAdd && (quick_add_type === FoodNoteItemQuickAddType.calorie || quick_add_type === FoodNoteItemQuickAddType.macros)) {
    return getDefaultCalorieOr3NutritionItemName(quick_add_type, kind, t);
  }

  return t('client_mgmt:normal.defaultName', '未命名食物');
};